<template>
  <v-container style="max-width:100vw;" v-if="currentUser">
    <v-navigation-drawer
      right
      app
      v-model="filtersOpen"
      style="top:0px; max-height:100vh!important;"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <filter-contacts @filtersContacts="onFiltersChanged" />
    </v-navigation-drawer>

    <v-data-table
      class="elevation-0 px-6 py-4"
      :headers="headers"
      :items="contacts"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      height="600"
      fixed-header
      :multi-sort="true"
      :footer-props="{ 'items-per-page-options': [15, 30, 50, 100, total>999?999:total] }"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-2">
          <v-toolbar-title>Contactos</v-toolbar-title>

          <!--v-btn icon @click="toggleFilters">
            <template v-if="activeFiltersCount>0">
              <v-badge overlap color="primary">
                <template v-slot:badge>{{ activeFiltersCount }}</template>
                <v-icon>mdi-filter</v-icon>
              </v-badge>
            </template>
            <template v-else>
              <v-icon>mdi-filter</v-icon>
            </template>
          </v-btn-->

          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:[`item.full_name`]="{ item }">
        {{ [item.name, item.last].filter(Boolean).join(' ') }}
      </template>

      <template v-slot:[`item.has_portal_access`]="{ item }">
        <v-chip x-small :color="item.has_portal_access ? 'green' : 'grey'" text-color="white">
          {{ item.has_portal_access ? 'Sí' : 'No' }}
        </v-chip>
      </template>

      <template v-slot:[`item.created_at`]="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template v-slot:[`item.updated_at`]="{ item }">
        {{ formatDate(item.updated_at) }}
      </template>

      <template v-slot:no-data>
        No existen contactos para los criterios seleccionados.
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from 'axios'
import FilterContacts from './filter.vue'

export default {
  name: 'ContactsContainer',
  components: { 'filter-contacts': FilterContacts },
  data: () => ({
    filtersOpen: false,
    loading: false,
    contacts: [],
    total: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: ['name'],
      sortDesc: [false],
    },
    headers: [
      { text: 'Nombre', value: 'full_name', sort: false },
      { text: 'Email', value: 'email', sort: false },
      { text: 'Teléfono', value: 'phone', sort: false },
      { text: 'Puesto', value: 'job_position', sort: false },
      { text: 'Acceso Portal', value: 'has_portal_access', sort: false }
    ],
  }),
  computed: {
    currentUser () {
      return (this.$store.state.currentUser && this.$store.state.currentUser.user) || null
    },
    activeFiltersCount () {
      const raw = localStorage.getItem('filtersContactsLength')
      const n = raw ? parseInt(raw, 10) : 0
      return Number.isNaN(n) ? 0 : n
    },
  },
  watch: {
    options: {
      deep: true,
      handler () { this.fetchContacts() }
    },
    currentUser () { this.fetchContacts() }
  },
  mounted () {
    this.fetchContacts()
  },
  methods: {
    toggleFilters () { this.filtersOpen = !this.filtersOpen },
    onFiltersChanged () { this.fetchContacts() },
    buildSortParam (sortBy, sortDesc) {
      const allowed = { name:1, last:1, email:1, phone:1, created_at:1 }
      if (!Array.isArray(sortBy) || !sortBy.length) return ''
      const parts = []
      for (let i = 0; i < sortBy.length; i++) {
        const key = sortBy[i]
        if (!allowed[key]) continue
        const desc = Array.isArray(sortDesc) && sortDesc[i] === true
        parts.push((desc ? '-' : '') + key)
      }
      return parts.length ? ('sort=' + parts.join(',') + '&') : ''
    },
    async fetchContacts () {
      this.loading = true
      try {
        const page = this.options.page
        const itemsPerPage = this.options.itemsPerPage
        const sortQS = this.buildSortParam(this.options.sortBy, this.options.sortDesc)
        const savedFilter = localStorage.getItem('filtersContacts')
        const filterQS = savedFilter ? JSON.parse(savedFilter) : ''
        const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/contacts?'
        const joiner = (sortQS || filterQS) ? '&' : ''
        const url = base + (sortQS || '') + (filterQS || '') + joiner + 'page=' + page + '&itemsPerPage=' + itemsPerPage

        const res = await axios.get(url)
        const rows = (res && res.data && res.data.data) ? res.data.data : []
        const total = (res && res.data && res.data.meta && res.data.meta.total) ? res.data.meta.total : rows.length

        this.contacts = this.mapContacts(rows)
        this.total = total
      } catch (e) {
        this.contacts = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    mapContacts (rows) {
      return rows.map(function (r) {
        return {
          id: r.id,
          name: r.name || '',
          last: r.last || '',
          email: r.email || '',
          phone: r.phone || '',
          job_position: r.job_position || '',
          company_name: (r.company && r.company.name) || (r.brand && r.brand.name) || '',
          agency_name: (r.agency && r.agency.name) || (r.company && r.company.agency && r.company.agency.name) || '',
          has_portal_access: !!r.has_portal_access,
          created_at: r.created_at || '',
          updated_at: r.updated_at || '',
        }
      })
    },
    formatDate (iso) {
      if (!iso) return ''
      const d = new Date(iso)
      return isNaN(d.getTime()) ? '' : iso.slice(0, 10)
    },
  }
}
</script>

<style>
.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  padding: 0 5px !important;
  font-size:10px!important;
}
.v-text-field--outlined fieldset { border-color: #e0e0e0; }
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td{ font-size:13px!important; }
</style>
